import { IndexaContributionsResponse } from './types';

export default async function getIndexaContributions(
	token: string,
	year?: number
): Promise<IndexaContributionsResponse> {
	const baseUrl = `${process.env.REACT_APP_BASE_API}/thirdparty/indexa/contributions`;
	const url = year !== undefined ? `${baseUrl}?year=${year}` : baseUrl;

	const response = await fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		throw new Error(`Network response was not ok: ${response.status}`);
	}

	const result: IndexaContributionsResponse = await response.json();
	return result;
}
